module.exports = __webpack_public_path__ + "img/156.9aa1dfef.png";